// extracted by mini-css-extract-plugin
export var impact = "Impact-module--impact--r5aQP";